import DetailTitle from "@/components/DetailTitle"
import { Input, Button, Form } from 'antd';
import styles from './index.module.scss'
import { useSelector, useDispatch } from 'react-redux';
import { setIsOpen } from "@/store/modules/user";
import { useMemo } from 'react';
import intl from "react-intl-universal";
import { addComment } from "@/apis/discover"

const { TextArea } = Input;
const NewComment = ({ resourceUuid,setTime }) => {
	const { userInfo } = useSelector(state => state.user)
	const dispatch = useDispatch()
	const useName = useMemo(() => userInfo?.username, [userInfo])
	const [form] = Form.useForm();

	const onFinish = (values) => {
		if (!useName) {
			dispatch(setIsOpen(true))
		} else {
			addComment({
				resourceUuid: resourceUuid,
				commentContent: values.comment
			}).then(res => {
				form.resetFields();
				setTime(new Date().getTime())
			})
		}
	}
	return (
		<div className={styles.newCommentBox}>
			<DetailTitle title="New Comment" />
			<Form
				onFinish={onFinish}
				autoComplete="off"
				size="large"
				form={form}
			>
				<Form.Item
					label=""
					name="comment"
					rules={[
						{
							required: true,
							message: intl.get('Share.Please input your comment'),
						},
					]}
				>
					<TextArea rows={5} />
				</Form.Item>

				<Form.Item>
					<Button htmlType="submit" type="primary">{intl.get('CommentBtn')}</Button>
				</Form.Item>
			</Form>

		</div>
	)
}
export default NewComment;